<template>
  <div class="view">
    <mu-paper :z-depth="2" class="form">
      <mu-button color="primary" @click="prev">
        <mu-icon left value="keyboard_arrow_left" :size="20"></mu-icon>
        上个月
      </mu-button>
      <mu-select v-model="form.year" class="year">
        <mu-option
          v-for="(item, index) in year"
          :key="index"
          :value="item"
          :label="item.toString()"
        ></mu-option>
      </mu-select>
      <mu-select v-model="form.month" class="month">
        <mu-option
          v-for="(item, index) in month"
          :key="index"
          :value="item"
          :label="item.toString()"
        ></mu-option>
      </mu-select>
      <mu-button color="primary" @click="next">
        <mu-icon left value="keyboard_arrow_right" :size="20"></mu-icon>
        下个月
      </mu-button>
      <mu-auto-complete
        :data="allCustomer"
        :max-search-results="5"
        v-model="form.customerStr"
        open-on-focus
        :filter="customerFilter"
        @select="customerSelect"
        class="customer"
        label="客户"
        label-float
      >
        <template slot-scope="scope">
          <mu-list-item-content v-html="scope.highlight"></mu-list-item-content>
        </template>
      </mu-auto-complete>
      <mu-button color="secondary" @click="getAll">
        <mu-icon left value="search" :size="20"></mu-icon>
        查找
      </mu-button>
      <mu-text-field
        v-model="orderId"
        placeholder="订单号"
        class="order"
      ></mu-text-field>
      <div class="analysis">
        <div class="total">
          共{{ count }}个订单，{{ unComplete }}个未完成，总金额{{
            sum
          }}元，已付{{ paid }}元，未付{{ unpaid }}元
        </div>
        <div class="detail">
          洛社店共{{ lsCount }}个订单，总金额{{ lsSum }}元，胡埭店共{{
            hdCount
          }}个订单，总金额{{ hdSum }}元
        </div>
      </div>
    </mu-paper>
    <mu-paper :z-depth="2" class="order" v-loading="loading">
      <div class="day" v-for="(item, index) in list" :key="index">
        <div class="day-title">
          {{
            `${item.day} 共${
              item.orders.length
            }个订单 总金额${item.sum.value()}元`
          }}
        </div>
        <div class="order-list">
          <div
            class="order-item"
            v-for="(order, orderIndex) in item.orders"
            :key="orderIndex"
            v-show="order.orderId.toString().indexOf(orderId) > -1"
          >
            <div class="order-title">
              {{
                `${order.orderId} ${order.customer.company} - ${order.customer.realName} 总金额：${order.sum}  已付金额${order.paid}`
              }}
              <span class="tag">{{
                order.clerk.id === HD_CLEKR_ID ? '胡埭' : '洛社'
              }}</span>
              <div class="button">
                <mu-button small color="#9c27b0" @click="sameOrder(order)">
                  <mu-icon left value="exposure_plus_1" :size="16"></mu-icon>
                  再下一单
                </mu-button>
                <mu-button small color="#ff5722" @click="openCAD(order)">
                  <mu-icon left value="file_copy" :size="16"></mu-icon>
                  CAD文件
                </mu-button>
                <mu-button small color="success" @click="excel(order)">
                  <mu-icon left value="view_module" :size="16"></mu-icon>
                  表格送货单
                </mu-button>
                <!-- <mu-button small color="#1565c0" @click="printOrder(order)">
                  <mu-icon left value="print" :size="16"></mu-icon>
                  打印订单
                </mu-button> -->
                <mu-button small color="success" @click="printInvoice(order)">
                  <mu-icon left value="send" :size="16"></mu-icon>
                  打印提货单
                </mu-button>
                <mu-button
                  small
                  color="primary"
                  @click="complete(order)"
                  :disabled="order.isComplete"
                >
                  <mu-icon left value="done_all" :size="16"></mu-icon>
                  {{ order.isComplete ? '已完成' : '完成' }}
                </mu-button>
                <mu-button small color="indigo500" @click="editOrder(order)">
                  <mu-icon left value="edit" :size="16"></mu-icon>
                  修改
                </mu-button>
                <mu-button
                  small
                  color="secondary"
                  @click="deleteOrder(order)"
                  :disabled="order.isToBeDelete"
                >
                  <mu-icon left value="delete" :size="16"></mu-icon>
                  {{ order.isToBeDelete ? '删除中' : '删除' }}
                </mu-button>
              </div>
            </div>
            <div class="product-list">
              <div
                class="product-item"
                v-for="(product, productIndex) in order.products"
                :key="productIndex"
              >
                <div class="img" @click="imageClick(order, productIndex)">
                  <img :src="product.pic + '!view'" />
                </div>
                <div class="name">
                  {{ `${product.name} * ${product.count}${product.unit}` }}
                </div>
                <div class="specification">
                  {{ product.specification }}
                </div>
                <div class="price">￥{{ product.price }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mu-paper>
    <Invoice :open.sync="invoiceOpen" :form="invoiceData"></Invoice>
    <ImageView
      :open.sync="imageOpen"
      :imageList="imageList"
      :active="imageViewActiveIndex"
    ></ImageView>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import backend, {downloadFileByTagA} from 'utils/backend'
import api from '@/api'
import Invoice from './invoice'
import numeral from 'numeral'
import ImageView from '@/components/imageView'
import { mapActions } from 'vuex'
import Message from 'muse-ui-message'

const HD_CLEKR_ID = 5
const LS_CLERK_ID = 146

export default {
  components: { Invoice, ImageView },
  data() {
    return {
      year: [],
      month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, '整年'],
      form: {
        year: moment().year(),
        month: moment().month() + 1,
        customerStr: '',
        customerId: null,
        relations: ['order.customer', 'order.products', 'order.clerk'],
        getAll: true
      },
      allCustomer: [],
      orderId: '',
      list: [],
      count: 0,
      sum: 0,
      paid: 0,
      unpaid: 0,
      unComplete: 0,
      invoiceData: {},
      invoiceOpen: false,
      loading: false,
      imageOpen: false,
      imageList: [],
      imageViewActiveIndex: 0,
      // 洛社定单数量
      lsCount: 0,
      lsSum: 0,
      // 胡埭定单数量
      hdCount: 0,
      hdSum: 0,
      LS_CLERK_ID: LS_CLERK_ID,
      HD_CLEKR_ID: HD_CLEKR_ID
    }
  },
  methods: {
    ...mapActions(['setMenuClickInOtherPage']),
    // 刷新
    getAll() {
      this.getAllOrder()
    },
    prev() {
      if (this.form.month === 1) {
        this.form.year--
        this.form.month = 12
      } else {
        this.form.month--
      }
      this.getAll()
    },
    next() {
      if (this.form.month === 12) {
        this.form.year++
        this.form.month = 1
      } else {
        this.form.month++
      }
      this.getAll()
    },
    yearInit() {
      const year = []
      for (let start = 2019; start <= moment().year(); start++) {
        year.push(start)
      }
      this.year = year
    },
    getAllCustomer() {
      backend(api.user.getAll, { getAll: true, isCustomer: true }).then(
        (result) => {
          if (result.statusCode === 200) {
            this.allCustomer = result.data.rows
          }
        }
      )
    },
    customerFilter(text, data, maxSearchResults) {
      return data
        .filter(
          (x) => x.realName.indexOf(text) > -1 || x.company.indexOf(text) > -1
        )
        .map((item) => {
          const value = item.company + ' - ' + item.realName
          return {
            value,
            item,
            highlight: `<span>${value.replace(
              text,
              '<span class="mu-secondary-text-color">' + text + '</span>'
            )}</span>`
          }
        })
    },
    customerSelect(value, item) {
      if (item) {
        this.form.customerId = item.id
      } else {
        this.form.customerId = null
      }
    },
    getAllOrder() {
      this.loading = true
      backend(api.order.getAll, this.form).then((result) => {
        this.loading = false
        if (result.statusCode === 200) {
          const arr = []
          let count = 0
          let unComplete = 0
          let sum = numeral(0)
          let paid = numeral(0)
          let unpaid = numeral(0)
          let lsCount = 0
          let lsSum = numeral(0)
          let hdCount = 0
          let hdSum = numeral(0)
          result.data.rows.forEach((item) => {
            sum.add(item.sum)
            paid.add(item.paid)
            unpaid.add(item.sum).subtract(item.paid)
            count++
            if (item.clerk.id === HD_CLEKR_ID) {
              hdCount++
              hdSum.add(item.sum)
            } else if (item.clerk.id === LS_CLERK_ID) {
              lsCount++
              lsSum.add(item.sum)
            }
            if (!item.isComplete) {
              unComplete++
            }
            const exist = arr.find(
              (x) => x.day === moment(item.createTime).format('YYYY年MM月DD日')
            )
            if (exist) {
              exist.orders.push(item)
              exist.sum.add(item.sum)
            } else {
              arr.push({
                day: moment(item.createTime).format('YYYY年MM月DD日'),
                orders: [item],
                sum: numeral(0).add(item.sum)
              })
            }
          })
          this.count = count
          this.unComplete = unComplete
          this.sum = sum.value()
          this.paid = paid.value()
          this.unpaid = unpaid.value()
          this.list = arr
          this.orderId = ''
          this.lsCount = lsCount
          this.lsSum = lsSum.value()
          this.hdCount = hdCount
          this.hdSum = hdSum.value()
        }
      })
    },
    openCAD(order) {
      const localPath = localStorage.getItem('local-path')
      const localPath2 = localStorage.getItem('local-path2')
      if (localPath) {
        const localFile = `${localPath}/${order.cadFile}`
        window.open(`cylaser://${localFile}`, '_self')
      } else if (localPath2) {
        const localFile = `${localPath2}/${order.cadFile}`
        axios.post(
          `http://localhost:12580/open/${encodeURIComponent(localFile)}`
        )
      } else {
        this.$toast.error('请先设置本地路径')
      }
    },
    printOrder(order) {
      window.open(order.pdfFile, '_blank')
    },
    printInvoice(order) {
      this.invoiceData = order
      this.invoiceOpen = true
    },
    excel(order) {
      backend(api.order.getExcel, { id: order.id }).then((result) => {
        if (result.statusCode === 200) {
          downloadFileByTagA(result.data.url, `${order.orderId}-${order.customer.company}.xlsx`)
        }
      })
    },
    complete(order) {
      backend(api.order.complete, order).then((result) => {
        if (result.statusCode === 200) {
          order.isComplete = true
          this.unComplete--
        }
      })
    },
    deleteOrder(order) {
      if (order.paid > 0) {
        this.$toast.error('当前订单已结账，无法删除')
        return
      }
      this.$prompt(
        '删除原因',
        `确认删除 ${order.customer.realName} - ${order.orderId}?`
      ).then(({ result, value }) => {
        if (result) {
          backend(api.order.deleteOrder, { id: order.id, reason: value }).then(
            (result) => {
              if (result.statusCode === 200) {
                this.$toast.success('申请成功，待审核')
                this.getAll()
              } else {
                this.$toast.error(result.msg)
              }
            }
          )
        }
      })
    },
    imageClick(order, index) {
      const arr = []
      order.products.forEach((item) => {
        if (item.pic) {
          arr.push({
            url: item.pic,
            title: `${item.name} - ${item.specification}`
          })
        }
      })
      if (arr.length > 0) {
        this.imageList = arr
        this.imageViewActiveIndex = index
        this.imageOpen = true
      } else {
        this.$toast.warning('无图片')
      }
    },
    editOrder(order) {
      this.setMenuClickInOtherPage({
        url: `/admin/order/editOrder/?id=${order.id}`,
        name: order.orderId,
        id: order.orderId
      })
    },
    // 再下一单
    sameOrder(order) {
      Message.confirm(
        `${order.customer.realName}--${order.orderId}，金额：${order.sum}元，确定再下一单？`,
        '确定再下一单？'
      ).then((result) => {
        this.loading = true
        if (result) {
          backend(api.order.sameOrder, order).then((result) => {
            if (result.statusCode === 200) {
              this.$toast.success('下单成功')
              if (
                moment(result.data.createTime).format('YYYYM') ===
                `${this.form.year}${this.form.month}`
              ) {
                this.getAll()
              }
            }
          })
        }
      })
    }
  },
  mounted() {
    this.yearInit()
    this.getAllCustomer()
    this.getAllOrder()
  },
  watch: {}
}
</script>

<style lang="less" scoped>
.view {
  display: flex;
  flex-direction: column;
  .form {
    padding: 10px;
    position: relative;
    .month,
    .year {
      margin-left: 20px;
      width: 100px;
    }
    .month {
      margin-right: 20px;
    }
    .customer {
      width: 250px;
      margin: 0 20px;
    }
    .order {
      position: absolute;
      right: 20px;
      top: 26px;
    }
    .analysis {
      // font-size: 18px;
      display: flex;
      justify-content: space-between;
    }
  }
  .order {
    flex: 1;
    margin-top: 20px;
    overflow-y: auto;
    .day {
      .day-title {
        line-height: 50px;
        padding-left: 30px;
        background: #009688;
        color: #fff;
        font-size: 18px;
      }
      .order-list {
        .order-item {
          .order-title {
            background: #e0e0e0;
            color: #333;
            font-size: 16px;
            padding-left: 30px;
            line-height: 40px;
            position: relative;
            .tag {
              color: #fff;
              background: #0170fe;
              padding: 0 8px;
              height: 24px;
              line-height: 24px;
              border-radius: 12px;
              margin-left: 10px;
              display: inline-block;
            }
            .button {
              position: absolute;
              right: 20px;
              top: 0;
            }
          }
          .product-list {
            padding: 20px;
            border-bottom: 1px solid #ddd;
            display: flex;
            flex-wrap: wrap;
            .product-item {
              display: flex;
              margin-left: 20px;
              flex-direction: column;
              .img {
                width: 186px;
                height: 186px;
                border: 1px solid #ddd;
                border-radius: 4px;
                padding: 6px;
                box-sizing: border-box;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                  display: block;
                }
              }
              .name,
              .specification,
              .price {
                text-align: center;
                line-height: 18px;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order/view.vue